<script setup lang="ts">
const userStripeAccount = useUserStripeAccount()
const stripeBalance = useStripeBalance()
const { colors } = useTheme()
</script>

<template>
  <AppNotificationBall v-if="userStripeAccount?.state === 'restricted'" :color="colors.orange" title="Payments Restricted">
    !
  </AppNotificationBall>
  <AppNotificationBall v-if="userStripeAccount?.state !== 'restricted' && stripeBalance.balance" :color="colors.primary" title="Receiving Payments">
    $
  </AppNotificationBall>
</template>
